export interface Manga {
  id: number;
  title: string;
  category: string;
  status: "连载中" | "完结";
  latestChapter: string;
  updateTime: string;
  totalChapters: number;
  progress: number; // 0-100
  cover: string;
  desc: string;
  tags: string[];
  isHot?: boolean;
}

export const serializingManga: Manga[] = [
  {
    id: 1,
    title: "吹雪之刃",
    category: "热血冒险",
    status: "连载中",
    latestChapter: "第 287 话 · 雪落无痕",
    updateTime: "2 小时前",
    totalChapters: 286,
    progress: 82,
    desc: "少年剑客在雪原尽头拔起断刃，踏上寻找失落剑脉的旅程。",
    tags: ["战斗", "少年", "热血"],
    isHot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20broken%20blade%20on%20a%20snowy%20cliff%20under%20blizzard%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20dynamic%20action%20composition%2C%20clean%20flat%20vector%20illustration%20style%2C%20subtle%20paper%20grain%20background&width=600&height=800&seq=coversnowblade&orientation=portrait",
  },
  {
    id: 2,
    title: "星海拾荒者",
    category: "科幻",
    status: "连载中",
    latestChapter: "第 198 话 · 废弃星港",
    updateTime: "5 小时前",
    totalChapters: 197,
    progress: 64,
    desc: "被放逐的少女机师在群星之间拾荒为生，卷入银河风暴的阴谋。",
    tags: ["星际", "冒险", "废土"],
    isHot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20female%20mecha%20pilot%20standing%20in%20an%20abandoned%20space%20port%20with%20twinkling%20stars%20and%20nebula%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20cinematic%20composition%2C%20clean%20flat%20vector%20illustration%20style%2C%20subtle%20paper%20texture&width=600&height=800&seq=coverstardrifter&orientation=portrait",
  },
  {
    id: 3,
    title: "舌尖上的妖怪",
    category: "日常美食",
    status: "连载中",
    latestChapter: "第 156 话 · 夜的关东煮",
    updateTime: "8 小时前",
    totalChapters: 155,
    progress: 71,
    desc: "半妖少年继承爷爷的深夜食堂，用美食化解人与妖怪的心结。",
    tags: ["治愈", "美食", "妖怪"],
    isHot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20half-demon%20boy%20chef%20serving%20steaming%20hot%20food%20at%20a%20night%20stall%20with%20friendly%20spirits%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20cozy%20composition%2C%20clean%20flat%20vector%20illustration%20style%2C%20subtle%20paper%20texture&width=600&height=800&seq=covertongue&orientation=portrait",
  },
  {
    id: 4,
    title: "术士的交易",
    category: "奇幻",
    status: "连载中",
    latestChapter: "第 124 话 · 灵魂契约",
    updateTime: "1 天前",
    totalChapters: 123,
    progress: 58,
    desc: "菜鸟术士与傲慢恶魔签订契约，却意外搅动了王国的权力漩涡。",
    tags: ["奇幻", "契约", "宫廷"],
    isHot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20wizard%20shaking%20hands%20with%20a%20sleek%20demon%20in%20a%20royal%20castle%20hall%20with%20glowing%20magic%20rune%20circle%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20dramatic%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverwizarddeal&orientation=portrait",
  },
  {
    id: 5,
    title: "重返十七岁",
    category: "青春校园",
    status: "连载中",
    latestChapter: "第 89 话 · 错过的那场雨",
    updateTime: "1 天前",
    totalChapters: 88,
    progress: 47,
    desc: "三十岁的社畜重回高中时代，决定把遗憾全部改写成夏天。",
    tags: ["校园", "治愈", "恋爱"],
    isHot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20teenage%20girl%20and%20boy%20under%20an%20umbrella%20on%20a%20sunny%20summer%20school%20rooftop%20with%20green%20trees%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20nostalgic%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverback17&orientation=portrait",
  },
  {
    id: 6,
    title: "降妖除魔录",
    category: "东方玄幻",
    status: "连载中",
    latestChapter: "第 312 话 · 镇妖塔底",
    updateTime: "3 天前",
    totalChapters: 311,
    progress: 90,
    desc: "落魄道士带着一只话痨妖狐，一路降妖伏魔闯遍三界。",
    tags: ["修仙", "搞笑", "冒险"],
    isHot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20shabby%20taoist%20priest%20with%20a%20talking%20white%20fox%20spirit%20facing%20a%20huge%20pagoda%20with%20floating%20talismans%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20whimsical%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverexorcism&orientation=portrait",
  },
  {
    id: 7,
    title: "心跳直播间",
    category: "都市恋爱",
    status: "连载中",
    latestChapter: "第 67 话 · 双人连麦",
    updateTime: "2 天前",
    totalChapters: 66,
    progress: 39,
    desc: "被迫营业的小主播，在深夜直播间遇见了最熟悉的陌生人。",
    tags: ["恋爱", "都市", "甜宠"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20charming%20young%20live-streamer%20girl%20in%20front%20of%20a%20neon%20lit%20studio%20desk%20with%20microphone%20and%20heart%20shapes%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20romantic%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverliveheart&orientation=portrait",
  },
  {
    id: 8,
    title: "机械之心",
    category: "机甲战斗",
    status: "连载中",
    latestChapter: "第 143 话 · 苏醒的核心",
    updateTime: "4 天前",
    totalChapters: 142,
    progress: 53,
    desc: "被植入机械心脏的少年，成为人类对抗失控机兽的最后武器。",
    tags: ["机甲", "战斗", "末世"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20boy%20with%20a%20glowing%20mechanical%20heart%20standing%20before%20a%20gigantic%20robot%20in%20a%20post-apocalyptic%20city%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20epic%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=covermechheart&orientation=portrait",
  },
  {
    id: 9,
    title: "山海食堂",
    category: "奇幻日常",
    status: "连载中",
    latestChapter: "第 78 话 · 河神的一碗面",
    updateTime: "6 小时前",
    totalChapters: 77,
    progress: 44,
    desc: "开在山海交界处的小面馆，招待的客人全是传说里的神兽。",
    tags: ["治愈", "美食", "神话"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20cozy%20small%20noodle%20shop%20by%20a%20misty%20mountain%20where%20mythical%20beasts%20dine%20at%20tables%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20cozy%20whimsical%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=covermountainsea&orientation=portrait",
  },
  {
    id: 10,
    title: "逆光骑士团",
    category: "热血冒险",
    status: "连载中",
    latestChapter: "第 210 话 · 破晓冲锋",
    updateTime: "5 天前",
    totalChapters: 209,
    progress: 76,
    desc: "一支被王国抛弃的骑士团，选择在阴影里守护黎明。",
    tags: ["骑士", "战斗", "群像"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20band%20of%20noble%20knights%20charging%20on%20horses%20toward%20a%20golden%20dawn%20over%20rolling%20hills%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20epic%20dynamic%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverknights&orientation=portrait",
  },
  {
    id: 11,
    title: "纸牌屋侦探",
    category: "悬疑推理",
    status: "连载中",
    latestChapter: "第 54 话 · 最后一张鬼牌",
    updateTime: "1 天前",
    totalChapters: 53,
    progress: 32,
    desc: "每桩凶案现场都留下一张纸牌，无名侦探与神秘庄家对赌真相。",
    tags: ["推理", "悬疑", "烧脑"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20mysterious%20detective%20in%20a%20trench%20coat%20holding%20a%20single%20playing%20card%20beside%20a%20dim%20table%20lamp%20and%20scattered%20evidence%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20noir%20mysterious%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=covercarddet&orientation=portrait",
  },
  {
    id: 12,
    title: "四季甜品铺",
    category: "治愈日常",
    status: "连载中",
    latestChapter: "第 42 话 · 秋天的栗子挞",
    updateTime: "1 天前",
    totalChapters: 41,
    progress: 27,
    desc: "小小甜品铺按季节更换菜单，甜品师记住每位客人的故事。",
    tags: ["治愈", "甜品", "日常"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20gentle%20pastry%20chef%20arranging%20colorful%20seasonal%20desserts%20in%20a%20cozy%20bakery%20window%20with%20autumn%20leaves%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20soft%20cozy%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverageoreshop&orientation=portrait",
  },
];

export const completedManga: Manga[] = [
  {
    id: 101,
    title: "苍海遗迹",
    category: "冒险",
    status: "完结",
    latestChapter: "全 128 话",
    updateTime: "已完结",
    totalChapters: 128,
    progress: 100,
    desc: "考古少女与沉默向导闯入沉没之城，揭开千年海图的秘密。",
    tags: ["冒险", "海洋", "经典"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20an%20archeologist%20girl%20and%20a%20guide%20approaching%20a%20sunken%20ancient%20city%20under%20the%20sea%20with%20rays%20of%20light%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20mysterious%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coveroceanruins&orientation=portrait",
  },
  {
    id: 102,
    title: "弦上月",
    category: "古风",
    status: "完结",
    latestChapter: "全 96 话",
    updateTime: "已完结",
    totalChapters: 96,
    progress: 100,
    desc: "乐师与将军在乱世中以琴音相认，一曲定江山。",
    tags: ["古风", "恋爱", "权谋"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20graceful%20ancient%20chinese%20lute%20player%20and%20a%20general%20under%20a%20full%20moon%20in%20a%20moonlit%20garden%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20elegant%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverlute&orientation=portrait",
  },
  {
    id: 103,
    title: "零号观测员",
    category: "科幻",
    status: "完结",
    latestChapter: "全 152 话",
    updateTime: "已完结",
    totalChapters: 152,
    progress: 100,
    desc: "观测平行宇宙的职员，偶然发现自己只是别人笔下的角色。",
    tags: ["科幻", "脑洞", "悬疑"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20scientist%20watching%20a%20wall%20of%20glowing%20floating%20screens%20showing%20parallel%20worlds%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20trippy%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverobserver&orientation=portrait",
  },
  {
    id: 104,
    title: "放学后的妖怪部",
    category: "校园",
    status: "完结",
    latestChapter: "全 84 话",
    updateTime: "已完结",
    totalChapters: 84,
    progress: 100,
    desc: "放学后专门处理校园怪谈的社团，笑闹中守护大家的日常。",
    tags: ["校园", "搞笑", "妖怪"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20group%20of%20playful%20high%20school%20students%20with%20cute%20little%20yokai%20spirits%20in%20a%20sunny%20after%20school%20clubroom%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20fun%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverafterschool&orientation=portrait",
  },
  {
    id: 105,
    title: "铁拳北境",
    category: "格斗",
    status: "完结",
    latestChapter: "全 208 话",
    updateTime: "已完结",
    totalChapters: 208,
    progress: 100,
    desc: "北境拳王带着一群少年，用拳头打穿黑暗的武道大会。",
    tags: ["格斗", "热血", "体育"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20muscular%20northern%20boxer%20clenching%20fists%20in%20a%20snowy%20arena%20with%20cheering%20crowd%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20powerful%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=covernorthfist&orientation=portrait",
  },
  {
    id: 106,
    title: "三千茶社",
    category: "治愈",
    status: "完结",
    latestChapter: "全 110 话",
    updateTime: "已完结",
    totalChapters: 110,
    progress: 100,
    desc: "一壶清茶，一盏灯火，茶社老板听尽人间悲欢。",
    tags: ["治愈", "人文", "日常"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20warm%20teahouse%20owner%20pouring%20tea%20by%20a%20paper%20lantern%20window%20with%20steam%20rising%20and%20guests%20talking%2C%20warm%20vermilion%20and%20amber%20color%20palette%2C%20peaceful%20cozy%20composition%2C%20clean%20flat%20vector%20illustration%20style&width=600&height=800&seq=coverteahouse&orientation=portrait",
  },
];